import { DatasheetSelection } from "../../common/DatasheetSelection";
import { defaultState } from "./types";
import { MainInterface } from "./components/MainInterface";
import { reducer, WelderContext } from "./reducer";
import { useReducer } from "react";
import { WeldSelection } from "./components/WeldSelection";
import { usePageStateGuard } from "@/hooks";

export function WelderRole() {
  const [state, updateState] = useReducer(reducer, defaultState);
  const currentPage = usePageStateGuard({
    2: Boolean(state.datasheet),
    3: Boolean(state.datasheet) && state.welds.length > 0,
  });

  return (
    <WelderContext.Provider value={{ state, updateState }}>
      {currentPage === 1 && <DatasheetSelection updateState={updateState} {...state} />}
      {currentPage === 2 && <WeldSelection />}
      {currentPage === 3 && <MainInterface />}
    </WelderContext.Provider>
  );
}
